import { createContentPropTypes } from '../../helpers/content';

const content = {
	reasonsPageHeader: 'What’s your payment for',
	reasonsPageSubHeader:
		'Letting us know your payment reason helps us to keep your money safe from fraud. We’ve got your back with some extra guidance and support if we feel your money’s at risk.',
	invalidPaymentReason: 'Hmm, looks like we’re missing something. Please let us know your payment reason.',
	dataToReview: 'Review',
	dateFormat: 'dddd, MMMM Do YYYY, h:mm:ss a',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	templateAmtLabel: 'Amount (optional)',
	refLabel: 'Reference',
	templateRefLabel: 'Reference (optional)',
	dateLabel: 'Date',
	balAfterLabel: 'Balance after payment',
	typeLabel: 'Payment type',
	startDateLabel: 'Start Date',
	endDateLabel: 'End Date',
	repeatingTypeLabel: 'Repeating Type',
	timesLabel: 'Times',
	reasonLabel: 'Reason for payment',
	reviewPageHeading: 'Review your payment',
	reviewPageSubHeading: "Please confirm the details you've entered are correct before you continue.",
	checkMyPayment: 'Check it’s safe to pay',
	continueText: 'Continue',
	cancelPaymentText: 'Cancel payment',
	reviewPaymentText: 'Review payment',
	backText: 'Back',
	doneText: 'Done',
	acknowledgement: {
		pageHeading: 'Could this be a scam?',
		pageSubHeading: 'Before you continue, we just want to help make sure you’re not being scammed',
		bulletPointsHeader: 'Watch out, it might be a scam if:',
		importantWarningDescription: 'Learn how to check it’s safe to make the payment.',
		helpMeText: 'Check my payment is safe',
	},
	safePayment: {
		pageHeading: 'Check it’s safe to pay',
		pageSubheading: 'Stop scammers in their tracks with these checks',
		pageSubheadingStatic: 'Let’s give you a bit more info about some of the common scams in this category',
		spotScamText: 'How to spot a scam',
		protectYourselfText: 'How to protect yourself',
		scammedHeading: 'I’m being scammed',
		scammedSubheading: 'If your money goes to a fraudster, you’re unlikely to get it back. If in doubt, head to our ',
		fraudAwarenessCentreText: 'fraud help centre.',
		fraudAwarenessCentreTextStatic: 'Visit our fraud help centre',
		errorText:
			'Hmm, looks like we’re missing something. Please tick the box to let us know you’re ready to make this payment.',
		declaration: 'I’m 100% sure this isn’t fraud',
	},
	cancelledPayment: {
		pageHeading: 'Payment cancelled',
		pageSubheading: 'You’ve made the right decision to cancel your payment if you think it might be fraud.',
		suspectFraudHeading: 'Report suspected fraud',
		suspectFraudSubheading:
			'If you suspect any fraud on your account(s) please contact us using the following details:',
		section1: 'For current accounts',
		section2: 'For business accounts',
		section3: 'Call charges and information',
		findOutMore: 'You can also find out more information at our ',
		fraudAwarenessCentreText: 'fraud help centre.',
		callWillBeRecorded: 'Calls may be recorded for training and quality purposes.',
		telCurrent: '0800 121 7365',
		telCurrentAbroad: '(+ 44 141 221 7300 if calling from abroad)',
		telBus: '0800 756 0800',
		telBusAbroad: '(+ 44 141 229 2626 if calling from abroad)',
		availability: 'We’re here 24 hours a day, 7 days a week',
	},
	reviewFields: [
		{
			key: 'Amount',
			orderId: 0,
			source: 'repeatData.amount',
			srcFunction: false,
			isAmount: true,
			isDate: false,
			isRepeating: true,
			isOneOff: true,
		},
		{
			key: 'Reference',
			orderId: 1,
			source: 'repeatData.reference',
			srcFunction: false,
			isAmount: false,
			isDate: false,
			isRepeating: true,
			isOneOff: true,
		},
		{
			key: 'Payment type',
			orderId: 2,
			source: 'repeatData.oneOffPayment',
			srcFunction: 'getPaymentType',
			isAmount: false,
			isDate: false,
			isRepeating: true,
			isOneOff: true,
		},
		{
			key: 'Start Date',
			orderId: 3,
			source: 'repeatData.startDate',
			srcFunction: false,
			isAmount: false,
			isDate: true,
			isRepeating: true,
			isOneOff: false,
		},
		{
			key: 'Repeating Type',
			orderId: 4,
			source: 'repeatData.howOften',
			srcFunction: 'getFrequencyName',
			isAmount: false,
			isDate: false,
			isRepeating: true,
			isOneOff: false,
		},
		{
			key: 'Times',
			orderId: 5,
			source: 'repeatData',
			srcFunction: 'getTimesValue',
			isAmount: false,
			isDate: false,
			isRepeating: true,
			isOneOff: false,
		},
		{
			key: 'End Date',
			orderId: 6,
			source: 'repeatData',
			srcFunction: 'getEndDate',
			isAmount: false,
			isDate: true,
			isRepeating: true,
			isOneOff: false,
		},
		{
			key: 'Date',
			orderId: 7,
			source: 'repeatData.futureDate',
			srcFunction: false,
			isAmount: false,
			isDate: true,
			isRepeating: false,
			isOneOff: true,
		},
		{
			key: 'Reason for payment',
			orderId: 8,
			source: 'effectiveWarningReason',
			srcFunction: false,
			isAmount: false,
			isDate: false,
			isRepeating: true,
			isOneOff: true,
		},
		{
			key: 'Balance after payment',
			orderId: 9,
			source: 'currentBalance',
			srcFunction: 'getRemainingBalance',
			isAmount: true,
			isDate: false,
			isRepeating: true,
			isOneOff: true,
		},
	],
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
